import type { ReactNode, SVGProps } from 'react'

/** Bij een verwijzing, naast de al bestaande brontekst (d2, R-58, R-157). */
export function SlotIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: 'var(--nwo-space-sp-3)', height: 'var(--nwo-space-sp-3)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <rect x="4" y="11" width="16" height="9" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  )
}
